/**
 * 搜索页状态管理工具函数
 * 用于保存和恢复搜索页的搜索状态（关键字、排序、频率筛选、Love 模式）
 */

const STORAGE_KEY = "searchPageState";

export interface SearchState {
    searchQuery: string;
    sortBy: "all" | "closingSoon" | "volume";
    frequency: "all" | "new" | "daily" | "weekly";
    isLoveMode: boolean;
}

/**
 * 保存搜索状态到 localStorage
 */
export function saveSearchState( state: SearchState ): void {
    if ( typeof window === "undefined" ) {
        return;
    }
    try {
        localStorage.setItem( STORAGE_KEY, JSON.stringify( state ) );
    } catch ( error ) {
        console.error( "Failed to save search state:", error );
    }
}

/**
 * 从 localStorage 恢复搜索状态
 */
export function restoreSearchState(): SearchState | null {
    if ( typeof window === "undefined" ) {
        return null;
    }
    try {
        const stored = localStorage.getItem( STORAGE_KEY );
        if ( !stored ) {
            return null;
        }
        const state = JSON.parse( stored ) as SearchState;
        return state;
    } catch ( error ) {
        console.error( "Failed to restore search state:", error );
        return null;
    }
}

/**
 * 清除保存的搜索状态
 */
export function clearSearchState(): void {
    if ( typeof window === "undefined" ) {
        return;
    }
    try {
        localStorage.removeItem( STORAGE_KEY );
    } catch ( error ) {
        console.error( "Failed to clear search state:", error );
    }
}
